export default __webpack_public_path__ + "static/media/amazonpay.6a963585.svg";